
import { IPerizia, IResult } from './../models/perizia.interface';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { UserService } from './user.service';
import { Observable } from 'rxjs';
import { IFile } from '../models/incarico.interface';
import { IChat } from '../components/chat/models/chat.interface';
import { Storage } from '@ionic/storage';
import { ToastController } from '@ionic/angular';
import { Md5 } from 'ts-md5/dist/md5';


@Injectable()
export class MysqlService {

  public uploadQueue: IFileQueue[] = []
  public uploadInProgress: number = null;
  public fileProgress = 0;

  URL_BASE = '';

  stati_perizia: any[];


  constructor(
    private http: HttpClient,
    router: Router,
    private userService: UserService,
    private ionicStorage: Storage,
    private toastController: ToastController,
  ) {

    this.URL_BASE = window.location.href.split('/').slice(0, 3).join('/');

    let host = window.location.href.split('/')[2].split(':')[0];

    let env = localStorage.getItem('ENVIRONMENT');

    switch (env) {
      case 'prod': this.URL_BASE = /*'https://xpert.i-expert.it/'*/ 'https://xpert.ggroup.cloud/'; break;
      case 'test': this.URL_BASE = 'https://xpert-test.i-expert.it/'; break;
    }


    this.URL_BASE += 'api/api.php?cmd=';

    console.log('list stati perizia')
    this.http.get(this.URL_BASE + 'list_perizia_stati').toPromise()
      .then((res: any[]) => {
        this.stati_perizia = res
        localStorage.setItem('stati_perizia', JSON.stringify(res))
      })
      .catch(err => console.error(err))

    this.initUploader()

  }

  

  utenti_validate_otp(otp: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      otp: otp
    }

    return this.http.post(this.URL_BASE + 'utenti_validate_otp', data).toPromise();

  }

  utenti_send_otp_by_email(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
    }

    return this.http.post(this.URL_BASE + 'utenti_send_otp_by_email', data).toPromise();

  }

  async initUploader() {
    await this.restoreUploadQueue(true);
  }

  getIonicStorage(key) {
    return this.ionicStorage.get(key)
  }

  async restoreUploadQueue(start: boolean) {

    //console.log('restoreUploadQueue')

    let tmp: IFileQueue[] = [];
    //if (this.platform.is('cordova')) {
    let n = await this.ionicStorage.length();
    if (n == 0) {
      this.uploadQueue = []
      //this.backgroundMode.disable();
      return;
    }

    await this.ionicStorage.forEach((value, key, index) => {


      if (key.substr(0, 3) == 'uq_') {
        tmp.push(JSON.parse(value))
      }


      //console.log('restoreUploadQueue' , value )

      n--;

      if (n <= 0) {
        this.uploadQueue = []
        this.uploadQueue = tmp;
        if (start) {
          //this.backgroundMode.enable();
          this.resumeUploadService();
        }
      }

    })


  }

  restartService() {
    this.uploadInProgress = null;
    this.restoreUploadQueue(true);
  }

  async resumeUploadService() {


    if (this.uploadInProgress) return;
    //this.setToastNotifyNfiles();


    for (let i = 0; i < this.uploadQueue.length; i++) {
      if (this.uploadQueue[i] == null) continue;
      this.uploadInProgress = i;

      //this.afStorage.ref(filename).delete()

      //this.uploadQueue[i].uploadTask = this.afStorage.ref(this.uploadQueue[i].filename).putString(this.uploadQueue[i].content, 'data_url')


      let data = {
        auth: this.userService.getCurrentUser(),
        data: this.uploadQueue[i]
      }

      this.http.post(this.URL_BASE + 'irepair_upload_file', data).toPromise()

        /*
              this.uploadQueue[i].uploadTask.snapshotChanges().subscribe(res => {
                this.setFilePercentage(res)
              })
        */
        //this.uploadQueue[i].uploadTask

        .then(async (res: any) => {

          console.log(res);


          if (res.status == 'OK') {

            //if (this.platform.is('cordova'))

            try {
              await this.ionicStorage.remove('uq_' + this.uploadQueue[i].filename).catch(err => console.log(err.message))
              console.log('foto caricata ' + this.uploadQueue[i].filename);
            } catch (error) {

            }




            //else
            //  localStorage.removeItem('uq_' + task.ref.fullPath)



          } else {

            /**
            let toast = await this.toastController.create({
              message: JSON.stringify(res.error),
              duration: 2000
            })
            toast.present()
            **/
            console.log("PIPPO")


          }



          this.uploadInProgress = null;
          this.restoreUploadQueue(true);

          return;


        }).catch(async err => {
          //alert(err.message);
          console.log(err);
          /**
          let toast = await this.toastController.create({
            message: err.message,
            duration: 2000
          })
          
          toast.present()
          **/


          this.uploadInProgress = null;
          this.restoreUploadQueue(true);

          return;

        })

      break;

    }

  }

  //////////////////////// iRepair /////////////////////////////////////


  irepair_print_checkin_custom_apeb(id) {
    return this.URL_BASE + `irepair_print_checkin_custom_apeb&token=${this.userService.getToken()}&email=${this.userService.getEmail()}&id=${id}`;
  }



  irepair_list(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
    }

    return this.http.post(this.URL_BASE + 'irepair_list', data).toPromise();
  }

  irepair_get(id): Promise<any> {

    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'irepair_get', data).toPromise();
  }

  irepair_upsert(item: any): Observable<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      item: item
    }
    const request = new HttpRequest('POST', this.URL_BASE + 'irepair_upsert', data, {
      reportProgress: true
    });



    return this.http.request(request);
  }

  irepair_delete(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'irepair_delete', data).toPromise();
  }

  irepair_clone(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    return this.http.post(this.URL_BASE + 'irepair_clone', data).toPromise();
  }


  irepair_get_result(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'irepair_get_result', data).toPromise();
  }

  async irepair_upsert_result(id: number, data: IResult): Promise<any> {


    console.log(data)

    for (let i = 0; i < data.fotoVetrina.length; i++) {
      data.fotoVetrina[i].url = null
      let url = await this.addFoto('' + id, 'foto_vetrina', data.fotoVetrina[i].id, data.fotoVetrina[i].img);
      //data.fotoVetrina[i].thumbData=null;
      if (url) {
        data.fotoVetrina[i].img = url
      }
    }

    for (let i = 0; i < data.altriElementi.length; i++) {
      data.altriElementi[i].url = null
      let url = await this.addFoto('' + id, 'altri_elementi', data.altriElementi[i].id, data.altriElementi[i].img);
      //data.altriElementi[i].thumbData=null;
      if (url) {
        data.altriElementi[i].img = url
      }
    }

    for (let i = 0; i < data.documenti.length; i++) {
      data.documenti[i].url = null
      let url = await this.addFoto('' + id, 'documenti', data.documenti[i].id, data.documenti[i].img);
      //data.documenti[i].thumbData=null;
      if (url) {
        data.documenti[i].img = url
      }
    }

    for (let i = 0; i < data.damages.length; i++) {
      data.damages[i].img1.url = null
      let url1 = await this.addFoto('' + id, 'danni', data.damages[i].img1.id, data.damages[i].img1.img);
      //data.damages[i].img1.thumbData=null;
      if (url1) {
        data.damages[i].img1.img = url1
      }

      data.damages[i].img2.url = null
      let url2 = await this.addFoto('' + id, 'danni', data.damages[i].img2.id, data.damages[i].img2.img);
      //data.damages[i].img2.thumbData=null;
      if (url2) {
        data.damages[i].img2.img = url2
      }


      if (data.damages[i].img_rip) {
        data.damages[i].img_rip.url = null
        let url_rip = await this.addFoto('' + id, 'danni', data.damages[i].img_rip.id, data.damages[i].img_rip.img);
        //data.damages[i].img2.thumbData=null;
        if (url2) {
          data.damages[i].img_rip.img = url_rip
        }
      }

      for (let j = 0; data.damages[i].extra && j < data.damages[i].extra.length; j++) {


        data.damages[i].extra[j].img1.url = null
        let url1 = await this.addFoto('' + id, 'danni', data.damages[i].extra[j].img1.id, data.damages[i].extra[j].img1.img);
        //data.damages[i].img1.thumbData=null;
        if (url1) {
          data.damages[i].extra[j].img1.img = url1
        }

        data.damages[i].extra[j].img2.url = null
        let url2 = await this.addFoto('' + id, 'danni', data.damages[i].extra[j].img2.id, data.damages[i].extra[j].img2.img);
        //data.damages[i].img2.thumbData=null;
        if (url2) {
          data.damages[i].extra[j].img2.img = url2
        }

        if (data.damages[i].extra[j].img_rip) {
          data.damages[i].extra[j].img_rip.url = null
          let url_rip = await this.addFoto('' + id, 'danni', data.damages[i].extra[j].img_rip.id, data.damages[i].extra[j].img_rip.img);
          //data.damages[i].img2.thumbData=null;
          if (url2) {
            data.damages[i].extra[j].img_rip.img = url_rip
          }
        }


      }



    }

    let datax = {
      auth: this.userService.getCurrentUser(),
      id: id,
      result: data
    }

    console.log(datax)

    return this.http.post(this.URL_BASE + 'irepair_upsert_result', datax).toPromise();
  }


  irepair_get_result_image_url(img: string) {
    return `${this.URL_BASE}irepair_get_result_image_url&img=${img}`;
  }

  irepair_get_result_image_data(url: string) {
    return this.http.get(url, { responseType: 'blob' }).toPromise()
  }



  //////////////////////////

  async addFoto(id: string, prefix: string, attachmentId: any, image: string) {
    if (!image || image == '') return null; // già uploadata
    if (image.slice(0, 4) == 'file') return null; // già uploadata

    //console.log('attachmentId', attachmentId)

    if (attachmentId == null) {
      console.log('init attachmentId')
      attachmentId = Md5.hashStr(image);
    }

    console.log(attachmentId)

    let filename = `files/irepair/${id}/${prefix}/${attachmentId}.jpg`;

    console.log(filename)

    this.pushtoUploadQueue(filename, image);

    return filename;

  }


  pushtoUploadQueue(filename: string, content: string) {


    let el: IFileQueue = {
      filename: filename,
      content: content
    }
    console.log('pushed', el)

    this.uploadQueue.push(el);
    this.backupUploadQueueElement(el)

    this.resumeUploadService();


  }

  async backupUploadQueueElement(el: IFileQueue) {
    try {
      await this.ionicStorage.set('uq_' + el.filename, JSON.stringify(el)).catch(err => alert(err.message))
    } catch (error) {
      alert(error.message)
    }
  }

  getFile(url): string {
    /*
      let storageRef = this.afStorage.storage.ref();
      let imageRef = storageRef.child(url)
      
      return imageRef.getDownloadURL()
   
      */

    return '';
  }


  ///////////////////////////////////////////////////////////////////////////////////////////

  cloudmessaging_upsert_device_id(token: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      deviceId: token
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'cloudmessaging_upsert_device_id', data).toPromise();
  }

  etax_list_marche(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser()
    }

    return this.http.post(this.URL_BASE + 'etax_list_marche', data).toPromise();
  }

  etax_list_anni(marca: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      marca: marca
    }

    return this.http.post(this.URL_BASE + 'etax_list_anni', data).toPromise();
  }

  etax_list_modelli(marca: string, anno: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      marca: marca,
      anno: anno
    }

    return this.http.post(this.URL_BASE + 'etax_list_modelli', data).toPromise();
  }

  etax_list_versioni(marca: string, anno: string, modello: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      marca: marca,
      anno: anno,
      modello: modello
    }

    return this.http.post(this.URL_BASE + 'etax_list_versioni', data).toPromise();
  }

  ///////////////////////////////////////////////////////////////////////////////////////////

  list_province(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser()
    }

    return this.http.post(this.URL_BASE + 'list_province', data).toPromise();
  }

  list_comuni(prov: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      prov: prov
    }

    return this.http.post(this.URL_BASE + 'list_comuni', data).toPromise();
  }

  ///////////////////////////////////////////////////////////////////////////////////////////

  get_print_adz(id: number, download: boolean) {
    return this.URL_BASE + 'print_adz&header=ie&id=' + id + (download ? '&download=1' : '');
  }

  get_print_adz_perizie(id: number, download: boolean, hash: string, thumb: boolean = false) {
    return this.URL_BASE + 'print_adz_perizie&header=ie&id=' + id
      + '&hash=' + hash
      + (download ? '&download=1' : '')
      + (thumb ? '&thumb=1' : '');
  }

  get_export_url() {
    return this.URL_BASE + 'export';
  }

  get_exp_tab1_url(id: number) {
    return this.URL_BASE + 'exp_tab1&id=' + id;
  }

  get_print_tab1_url(id: number) {
    return this.URL_BASE + 'print_tab1&id=' + id;
  }


  //////////////////////////////////////////////////////////////////////////////////////////

  get_perizia(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    return this.http.post(this.URL_BASE + 'get_perizia', data).toPromise();
  }


  get_perizia_attachment_url(id: number, f: IFile, type: string) {
    return `${this.URL_BASE}get_perizia_attachment&id=${id}&hash=${f.hash}&filename=${f.fileName}&type=${type}`;
  }

  list_perizie(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser()
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + 'list_perizie', data).toPromise();
  }

  list_storico_perizia(id: number): Promise<any> {
    return this.list_storico('perizie', id)
  }

  list_storico(table: string, id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      table: table,
      id: id
    }

    return this.http.post(this.URL_BASE + 'list_storico', data).toPromise();
  }

  list_logs_perizia(id: number): Promise<any> {
    return this.list_logs('perizie', id)
  }

  list_logs(table: string, id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      table: table,
      id: id
    }

    return this.http.post(this.URL_BASE + 'list_logs', data).toPromise();
  }

  upsert_perizia(item: IPerizia): Observable<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      item: item
    }


    const request = new HttpRequest('POST', this.URL_BASE + 'upsert_perizia', data, {
      reportProgress: true
    });



    return this.http.request(request);
  }

  upsert_perizia_accept_reject(id: number, nextStatus: string): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      nextStatus: nextStatus
    }

    return this.http.post(this.URL_BASE + 'upsert_perizia_accept_reject', data).toPromise();
  }


  upsert_allegati_perizia(item: IPerizia): Observable<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      item: item
    }


    const request = new HttpRequest('POST', this.URL_BASE + 'upsert_allegati_perizia', data, {
      reportProgress: true
    });



    return this.http.request(request);
  }

  delete_perizia(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    return this.http.post(this.URL_BASE + 'delete_perizia', data).toPromise();
  }



  get_current_user_profile(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
    }

    return this.http.post(this.URL_BASE + 'get_current_user_profile', data).toPromise();

  }

  //////////////////////////////////////////////////////////////////////////////////////////


  getListChat(code: string, email: string): Observable<IChat[]> {

    let data = {
      auth: this.userService.getCurrentUser(),
      code: code,
      email: email
    }

    return this.http.post<IChat[]>(this.URL_BASE + 'list-chat', data);

  }


  getListChatNotifies(): Promise<any> {

    let data = {
      auth: this.userService.getCurrentUser()
    }

    return this.http.post<IChat[]>(this.URL_BASE + 'list-chat-notifies', data).toPromise();

  }

  addChat(chat: IChat): Promise<any> {

    if (!chat.sender) chat.sender = this.userService.getCurrentUser().email;

    let data = {
      auth: this.userService.getCurrentUser(),
      data: chat
    }

    console.log(data)

    return this.http.post<IChat[]>(this.URL_BASE + 'add-chat', data).toPromise();

  }


  //////////////////////////////////////////////////////////////////////////////////////////

  login(email: string, password: string): Promise<any> {

    return this.http.post(this.URL_BASE + 'login', { email: email, password: password }).toPromise();

  }

  get_stats(): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser()
    }
    return this.http.post(this.URL_BASE + 'get_stats', data).toPromise();

  }

  getTipoPerizia() {
    return [
      'RC Auto',
      'Kasco collisione',
      'Fenomeni socio-politici',
      'Furto totale con ritrovamento',
      'Incendio e scoppio',
      'RC Prodotto',
      'Rivalse',
      'Globale fabbricati',
      'Danno merci',
      'Preassuntiva',
      'Kasco completa',
      'Atti vandalici',
      'Fenomeni naturali',
      'Furto parziale',
      'Cristalli',
      'RC Professionale',
      'RC Generale',
      'Acqua condotta',
      'Merci trasportate',
      'Stato d\'uso',
    ]
  }

  getStatiPerizia(): any[] {

    if (this.stati_perizia) {
      return this.stati_perizia;
    }

    if (!this.stati_perizia) {
      return JSON.parse(localStorage.getItem('stati_perizia'));
    }


  }

  getStato(sts) {

    let stati = this.getStatiPerizia();


    for (let i = 0; i < stati.length; i++) {
      if (sts == stati[i].sts) {
        return stati[i]
      }
    }

    return { competence: '' };
  }

  getStatiPeriziaAll(): string[] {
    let stati = this.getStatiPerizia();

    let r = [];
    for (let i = 0; i < stati.length; i++) {
      r.push(stati[i].sts);
    }

    return r;
  }

  getStatiPeriziaAll_client(): string[] {
    let stati = this.getStatiPerizia();

    let r = [];
    for (let i = 0; i < stati.length; i++) {
      r.push(stati[i].clientDescription);
    }

    r = r.filter((value, index, self) => {
      return self.indexOf(value) === index;
    });

    return r;
  }

  getPeriziaStatusFilter(): any[] {
    let r = [];
    let arr = this.userService.getCurrentUser().role == 'CLIENTE' ? this.getStatiPeriziaAll_client() : this.getStatiPeriziaAll();
    for (let e of arr) {
      r.push({ value: e, title: e })
    }
    return r;
  }

  ///////////////FORM////////////////////
  forms_get(id: number): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'forms_get', data).toPromise();

  }

  forms_save_value(id, value): Promise<any> {
    let data = {
      auth: this.userService.getCurrentUser(),
      id: id,
      value: value
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + 'forms_save_value', data).toPromise();
  }

  forms_get_print_url(id, hash) {
    return this.URL_BASE + `forms_print&token=${this.userService.getToken()}&email=${this.userService.getEmail()}&id=${id}&hash=${hash}`;
  }



  ////////////// ETAX /////////////////////

  etax_search_plate(plate: string) {

    let data = {
      auth: this.userService.getCurrentUser(),
      plate: plate
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'etax_search_plate', data).toPromise();

  }


  /////////////// AWS TEXTRACT /////////////////

  aws_textract_analyze_document(imgData: string) {

    let data = {
      auth: this.userService.getCurrentUser(),
      content: imgData
    }

    console.log(data)

    return this.http.post(this.URL_BASE + 'aws_textract_analyze_document', data).toPromise();

  }


}



export interface IFileQueue {
  filename: string;
  content: string;
  uploadTask?: any;
}
